<template>
  <v-form>
    <v-container>
      <span v-if="editMotorId == -1" class="headline">Create Motor</span>
      <span v-if="editMotorId != -1" class="headline">Edit Motor</span>
      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
            <v-select v-model="motor.type" :items="motorTypes" label="Type"></v-select>


        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.power" suffix="HP" label="Power" required></v-text-field>
        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.nominal_current" suffix="A" label="Nominal Current" required></v-text-field>
        </v-col>

         
      </v-row>

      <v-row>
                <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motor.axial_load_capacity"
            suffix="kN"
            label="Axial Load Capacity"
            required
          ></v-text-field>
        </v-col>

         <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.starting" suffix="" label="Starting" required></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field
            v-model="motor.nominal_effiency"
            suffix="%"
            label="Nominal Effiency"
            required
          ></v-text-field>
        </v-col>



        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.effiency" suffix="%" label="Effiency" required></v-text-field>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.load_rate" suffix="%" label="Load Rate" required></v-text-field>
        </v-col>
      </v-row>  -->

      <v-row>
       


        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field
            v-model="motor.nominal_diameter"
            suffix="''"
            label="Nominal Diameter"
            required
          ></v-text-field>
        </v-col> -->

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.length" suffix="m" label="Length" required></v-text-field>
        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.weight" suffix="kg" label="Weight" required></v-text-field>
        </v-col>
      </v-row>
  <v-row>
       <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.price" suffix="$" label="Price" required></v-text-field>
        </v-col>
      </v-row>
      <div class="my-2">
        <v-btn v-if="editMotorId == -1" color="primary" @click="saveMotor">Save</v-btn>
        <v-btn v-if="editMotorId != -1" color="primary" @click="saveMotor">Update</v-btn>
        
      </div>
    </v-container>
  </v-form>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",

  data: () => ({
    token: '',
    query: '',
    motorTypes: [],
    motor: {
      idmotor: -1,
      type: "",
      power: "25",
      nominal_diameter: "11",
      nominal_current: "13",
      length: 100,
      weight: 4,
      nominal_effiency: "75",
      effiency: "77",
      axial_load_capacity: 80,
      price: "",
      starting: "Y - Δ",
      
    }
  }),

  props : {
    editMotorId: {
      type: String,
      default: '-1'
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
      if ( this.editMotorId != -1){
        this.fetchMotor(this.editMotorId)
      }
      this.fetchMotorTypes()
  },

  methods: {
    fetchMotorTypes: function() {
      this.motorTypes = [];
      this.$http.get(this.$API_URL + "motor_types").then(result => {
        result.data.forEach(motorType => {
          this.motorTypes.push({
            text: motorType.type +", "+motorType.phase+" phase, "+motorType.voltage+" V, "+
            motorType.fi_d_max+" mm",
            value: motorType.idmotor_type
          });
        });
      });
    },
    fetchMotor: function(editMotorId) {
      this.$http.get(this.$API_URL + "motor?idmotor=" + editMotorId).then(result => {
        this.motor = result.data
      });
    },
    saveMotor: function() {
      var targetUrl = this.editMotorId == -1 ? "save_motor" : "update_motor";
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.motor,
        query: {
          update: true
        }
      })
        .then(function(response) {
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
